angular.module('harriApp')
    .controller('CareerStoryPageContainer', ['$scope', 'careerStoryPageService', '$modal', 'CareerPortalDataBus', 'appLayoutViewService', '$window', 'hUser', 'JobDetailsBus', 'jobApplyFactory', 'hEvent', '$stateParams', function ($scope, careerStoryPageService, $modal, CareerPortalDataBus, appLayoutViewService, $window, hUser, JobDetailsBus, jobApplyFactory, hEvent, $stateParams) {
        var self = this;
        let talentScoutCodeId = $stateParams['talent_scout_code_id']
        const SCROLL_THRESHOLD = 320;
        let heroCarouselInterval;
        let heroCarouselIndex = 0;
        let scrollToTopBtn = $('.scroll-to-top')
        let carouselsData = [];

        function bindScrollToTopButton() {
            function handleScroll() {
                if (document.body.scrollTop > SCROLL_THRESHOLD || document.documentElement.scrollTop > SCROLL_THRESHOLD) {
                    scrollToTopBtn.css('display', 'block');
                } else {
                    scrollToTopBtn.css('display', 'none');
                }
            }
            window.onscroll = handleScroll;
            scrollToTopBtn.on('click', () => {
                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        }

        const scrollToSection = (sectionName) => {
            const section = document.getElementById(sectionName);

            if (section) {
                section.scrollIntoView({behavior: 'smooth'});
            }
        };

        $scope.showJobAlertsModal = () => {
            $modal({
                controller: 'getJobAlertsModal',
                templateUrl: '../modules/profiles/modals/get-job-alerts/get-job-alerts.modal.html',
                show: true,
                resolve: {
                    modalData: () => {
                        return {
                            brand: CareerPortalDataBus.getBasicInfo(),
                            positions_codes: [],
                            onSuccess: (res) => {
                                HNotifications.show({
                                    title: $filter("translate")("A verification email has been sent to your email account"),
                                    desc: $filter("translate")("Click on the link to verify your subscription and start receiving ") + CareerPortalDataBus.getBasicInfo().name + $filter("translate")(" job alerts"),
                                    icon: "fa-check",
                                    type: "success",
                                    timeout: 4000
                                });
                            },
                            onError: (err, email) => {
                                HNotifications.show({
                                    title: $filter("translate")("Email already exists"),
                                    desc: email + " " + $filter("translate")("email already have jobs alerts for") + " " + CareerPortalDataBus.getBasicInfo().name,
                                    icon: "fa-info-circle",
                                    type: "danger",
                                    timeout: 10000
                                });
                            }
                        };
                    }
                }
            });
        };

        $scope.showApplyToTalentPoolModal = () => {
            const applyUrl = `careers/${CareerPortalDataBus.getBasicInfo().slug}/apply/${$scope.talentPoolJob.id}${talentScoutCodeId ? `?talent_scout_code_id=${talentScoutCodeId}` : ''}`;
            $('.join-talent-pool').attr('href', applyUrl);
        }

        JobDetailsBus.onJobApplyFinish = async (status, appId, applyDate, jobId) => {
            if ([JobDetailsBus.SUCCESS, JobDetailsBus.SUCCESS_NO_PASSWORD].indexOf(status) > -1) {
                jobApplyFactory.PrepareApplySuccessModal(jobId).then((data)=>{
                    $.extend($scope, data)
                    jobApplyFactory.showApplySuccessModal();
                    $scope.$digest();
                });
            }
        };

        const getCareerPortalHref = () => {
            let basicInfo = CareerPortalDataBus.getBasicInfo();
            if (basicInfo && basicInfo.slug) {
                window.open(`/${basicInfo.slug}${talentScoutCodeId ? `?talent_scout_code_id=${talentScoutCodeId}` : ''}`, '_blank');
            }
        };

        const updateBrandTheme = () => {
            let profileImage;
            if (CareerPortalDataBus.getBasicInfo().media) {
                profileImage = _.findWhere(CareerPortalDataBus.getBasicInfo().media, {'type': 'profile_image'});
            }
            $scope.theme = {
                scheme_settings: CareerPortalDataBus.getBasicInfo().scheme_settings,
                profile_image: profileImage || null,
            }
            appLayoutViewService.updateBrandTheme($scope.theme, 'csp_theme');
        }

        function scrollToFirstSection() {
            let careerStoryPagesDetails = careerStoryPageService.getCareerStoryPageData();
            let sectionId = careerStoryPagesDetails.middle_section[0].name;
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({behavior: 'smooth'});
            }
        }

        const initHeroCarousel = (value) => {
            const data = careerStoryPageService.getCareerStoryPageData();
            if (data.hero_section.media_type === 'CAROUSEL') {
                clearTimeout(heroCarouselInterval);

                heroCarouselIndex += value;
                const slides = $(`.hero-carousel-images`);

                if (slides.length) {
                    heroCarouselInterval = setTimeout(() => initHeroCarousel(1), 4000);
                    heroCarouselIndex = (heroCarouselIndex < 0) ? slides.length - 1 : (heroCarouselIndex === slides.length) ? 0 : heroCarouselIndex;

                    slides.css('display', 'none');
                    slides.eq(heroCarouselIndex).css('display', 'block');
                }
            }
        }

        $scope.getHeroHrefURL = () => {
            let data = careerStoryPageService.getCareerStoryPageData();
            return data.hero_section.image ? `url(${data.hero_section.image})` : null
        }

        const initMiddleSectionsCarouselsSlide = () => {
            let CspData = careerStoryPageService.getCareerStoryPageData();
            const slideCarousel = (sectionOrder, value) => {
                let carouselData = carouselsData.find(carousel=>carousel.carouselRank === sectionOrder);
                clearTimeout(carouselData.interval);

                carouselData.index += value;
                const slides = $(`.csp-carousel-slides-${sectionOrder}`);

                if (slides.length) {
                    carouselData.interval = setTimeout(() => slideCarousel(sectionOrder, 1), 4000);
                    carouselData.index = (carouselData.index < 0) ? slides.length - 1 : (carouselData.index === slides.length) ? 0 : carouselData.index;

                    slides.css('display', 'none');
                    slides.eq(carouselData.index).css('display', 'block');

                    const buttons = $(`.carousel-control-button-${sectionOrder}`);
                    buttons.removeClass('hui-accent')
                    buttons.addClass('bg-white')
                    buttons.eq(carouselData.index).removeClass('bg-white');
                    buttons.eq(carouselData.index).addClass('hui-accent');
                }
            }

            const goToIndex = (sectionOrder, index) => {
                let carouselData = carouselsData.find(carousel=>carousel.carouselRank === sectionOrder);
                clearTimeout(carouselData.interval);
                carouselData.index = index;
                slideCarousel(sectionOrder, 0);
            }

            for (let i in CspData.middle_section) {
                const section = CspData.middle_section[i];
                if (section.carousel) {
                    carouselsData.push({carouselRank: section.rank, interval: undefined, index: 0})
                    slideCarousel(section.rank, 0)
                }
            }

            $('.carousel-control-button').on("click", (event)=> {
                const sectionRank = $(event.currentTarget).data("section-rank");
                const imageIndex = $(event.currentTarget).data("image-index");
                goToIndex(sectionRank, imageIndex);
            })
        }

        $scope.showEmbedVideo = (sectionOrder) => {
            $(`.hosted-media-video-${sectionOrder}`).css('display', 'block');
            $(`.hosted-play-button-${sectionOrder}`).css('display', 'none');
            $(`.hosted-video-background-${sectionOrder}`).css('background-image', 'none');
        }

        self.$onInit = () => {
            bindScrollToTopButton();
            $('.view-all-jobs-btn').on("click", () => {
                getCareerPortalHref();
            });

            $('.go-next-btn').on("click", () => {
                scrollToFirstSection();
            });

            $('.nav-link').on("click", (event) => {
                event.stopPropagation();
                scrollToSection(event.target.innerText);
            });

            $('.hero-video-control').on("click", ()=>{
                const videoPlayer = $('.hero-video-player').get(0);
                const playButton = $('.hero-video-control .fa-play');
                const pauseButton = $('.hero-video-control .fa-pause');
                if (videoPlayer.paused) {
                    videoPlayer.play();
                    playButton.css('display', 'none');
                    pauseButton.css('display', 'block');
                } else {
                    videoPlayer.pause();
                    playButton.css('display', 'block');
                    pauseButton.css('display', 'none');
                }
            })

            updateBrandTheme();
            if ($scope.theme.scheme_settings) {
                let accentColor = ($scope.theme.scheme_settings?.accent_color || '#0088DD');
                document.documentElement.style.setProperty('--accent-color', accentColor);
            } else {
                document.documentElement.style.setProperty('--accent-color', '#0088DD');
            }

            appLayoutViewService.updateBrandTheme($scope.theme, 'csp_theme');

            let viewAllJobsBtn = document.getElementById('viewAllJobsBtn');
            let container = angular.element(document.querySelector('.career-portal-landing-page-container'));
            angular.element($window).on('scroll.career-portal-landing-page-container', () => {
                if ($window.scrollY > 0 &&  !($window.scrollY > (container.offset().top + container.height() - $(window).height()))
                ) {
                    viewAllJobsBtn.classList.add('fixed-bottom-center');
                } else {
                    viewAllJobsBtn.classList.remove('fixed-bottom-center');
                }
            });
            initHeroCarousel(0);

            let basicInfo = CareerPortalDataBus.getBasicInfo();
            if (basicInfo.public_services?.includes('GLOBAL_TALENT_POOL') &&
                basicInfo.global_talent_pool_settings?.apply_to_talent_pool) {
                CoreReaderAPI.getTalentPoolJobs(basicInfo.id)
                    .then(talentPoolJob => {
                        if (Object.keys(talentPoolJob).length === 0) {
                            $('.join-talent-pool').removeClass('d-block').addClass('d-none');
                        } else {
                            $scope.talentPoolJob = talentPoolJob;
                            $('.join-talent-pool').removeClass('d-none').addClass('d-block');
                        }
                    });
            }
            initMiddleSectionsCarouselsSlide();
        };

        self.$onChanges = () => {

        };

        self.$onDestroy = () => {

        };

    }]);